
<style src="./Login.scss" lang="scss"></style>
<script src="./Login.js"></script>

<template>
  <div class="
      login-register-area
      section-padding-1
      pt-50
      pb-100
    ">
    <div class="container">
      <div class="row login-register-row">
        <div class="col-lg-7 col-md-6">
          <LoginForm />
        </div>
        <div class="col-lg-5 col-md-6">
          <SignUpForm />
        </div>
      </div>

    </div>
  </div>
</template>
